export default "__VITE_ASSET__BB4flZ$0__"